"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();
  const [retrying, setRetrying] = useState(false);

  useEffect(() => {
    console.error("Application error:", error);
  }, [error]);

  const handleRetry = () => {
    setRetrying(true);
    reset();
    setTimeout(() => setRetrying(false), 3000);
  };

  return (
    <html>
      <body>
        <div className="min-h-screen bg-[#E1F5EE] flex items-center justify-center px-4">
          <div className="text-center max-w-lg">
            <div className="text-[80px] leading-none">💥</div>
            <h1 className="text-2xl font-serif font-bold text-gray-900 mt-4">
              Something broke.
            </h1>
            <p className="text-gray-500 mt-3 leading-relaxed">
              Surprise! The app crashed. We'd blame it on the intern, but we're
              a SaaS product — we're the intern.
            </p>
            <p className="text-gray-400 text-sm mt-4 font-mono bg-gray-100 px-3 py-2 rounded-lg text-left break-all">
              {error.message || "Unknown error"}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
              <Button
                onClick={handleRetry}
                disabled={retrying}
                className="bg-[#1D9E75] hover:bg-[#1a8b66] text-white gap-2 cursor-pointer disabled:opacity-50"
              >
                {retrying ? "Trying again..." : "Try again (it might work this time)"}
              </Button>
              <Button
                variant="outline"
                onClick={() => router.push("/home")}
                className="cursor-pointer"
              >
                Go home (where things actually work)
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
